import { render, staticRenderFns } from "./Entrance.vue?vue&type=template&id=1ddd585f"
import script from "./Entrance.vue?vue&type=script&lang=js"
export * from "./Entrance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports